import { PlusOutlined, MoreOutlined, DeleteOutlined, FormOutlined } from '@ant-design/icons'
import { makeStyles } from '@material-ui/core'
import { Badge, Space, Table, Popconfirm, Popover, Button } from 'antd'
import moment from 'moment'
import React, {useEffect, useState} from 'react'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { useData } from '../../../../data'
import { CTAButton } from '../../components'
import NewScrapyServer from './new'
import UpdateScrapyServer from './edit'

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        width: '100%'
    },
    topBar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    content: {
        padding: theme.spacing(3, 0)
    },
    table: {
        maxWidth: '100%',
        width: '100%'
    }
}))

/**
 * Admin page to manage scrapy servers
 */
const ScrapyServer = (props) => {
    const [servers, setServers] = useState([])
    const [show, setShow] = useState(false)
    const [editShow, setEditShow] = useState(false)
    const [server, setServer] = useState({})
    const classes = useStyles()
    const data = useData()
    const scrapy_server = data.scrapyServer()

    const newServer = () => setShow(true)
    const updateServer = (record) => {
            setEditShow(true);
            setServer(record);
        }

    const serverSchema = [
        {
            title: 'ID',
            key: 'id',
            dataIndex: 'id'
        },
        {
            title: 'Scrapy URL',
            key: 'scrapy_url',
            dataIndex: 'scrapy_url'
        },
        {
            title: 'Capacity',
            key: 'capacity',
            dataIndex: 'capacity'
        },
        {
            title: 'Status',
            key: 'status',
            dataIndex: 'status',
            render: (status) => 
            <Space>
                <Badge
                    className="site-badge-count-109"
                    count={status? "Active": "Inactive"}
                    style={{ backgroundColor: status? "#52c41a": "" }}
                />
            </Space>
        },
        {
            title: 'Date Created',
            key: 'created_at',
            dataIndex: 'created_at',
            render: (date) => moment(date).format("YYYY-MM-DD HH:mm")
        },
        {
            title: 'Date Updated',
            key: 'updated_at',
            dataIndex: 'updated_at',
            render: (updated_at) => moment(updated_at).format("YYYY-MM-DD HH:mm")
        },
        {
            key: 'Actions',
            title: 'Actions',
            render: (_, record) => {
                return (
                <Space>
                    <Button type='primary' size='small' onClick={() => updateServer(record)}  icon={<FormOutlined />} />
                    <Popconfirm
                        title="Are you sure to delete this scrapy server?"
                        onConfirm={ () => deleteServer(record.id) }
                        okText="Yes"
                        cancelText="No"
                    >
                    <Button danger size='small'  icon={<DeleteOutlined />} />
                    </Popconfirm>
                </Space>
                )
            }
        },
    ]

    const deleteServer = ( id ) => {
        scrapy_server.deleteServer(id)
            .then((data) => {
                loadScrapyServers()
            })
    }

    const loadScrapyServers = () => {
        trackPromise(
            scrapy_server.getServers()
                .then(a => {
                    console.log(a)
                    setServers(a)
                })
                .catch(console.log)
        )
    }

    // load the accounts
    useEffect(() => {
        loadScrapyServers()
    }, [])

    const {promiseInProgress} = usePromiseTracker()

    const closeDrawer = () => {
        setShow(false)
        setEditShow(false)
        loadScrapyServers()
    }

    return (
        <div className={classes.root}>
            <div className={classes.topBar}>
                <h1>Scrapy Servers</h1>
                <CTAButton onClick={newServer}>
                    <Space>
                        <PlusOutlined />
                        Add Server
                    </Space>
                </CTAButton>
            </div>

            <div className={classes.content}>
                <Table
                    columns={serverSchema}
                    className={classes.table}
                    loading={promiseInProgress}
                    dataSource={servers}
                />
            </div>

            <NewScrapyServer visible={show} close={closeDrawer} />
            <UpdateScrapyServer server={server} visible={editShow} close={closeDrawer} />
        </div>
    )
}

export default ScrapyServer
